import { render, staticRenderFns } from "./Emailcampaign.vue?vue&type=template&id=b91b3002&"
import script from "./Emailcampaign.vue?vue&type=script&lang=js&"
export * from "./Emailcampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports